import { createEntityAdapter } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { createAppSlice } from "../../../shared/lib/store/createAppSlice.js";
import { name } from "../config/name.js";
const adapter = createEntityAdapter({
  sortComparer: (a, b) => b.addedBy - a.addedBy
});
const initialState = {
  ...adapter.getInitialState(),
  isIrrelevant: false,
  options: {
    offset: 0,
    limit: 12,
    sort: ["price"]
  }
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    addItem: adapter.addOne,
    removeItem: adapter.removeOne,
    removeAllItems: adapter.removeAll,
    actualizeItems: (state, action) => {
      const outdatedItems = state.ids.filter((id) => !action.payload.includes(id));
      if (outdatedItems.length > 0) {
        adapter.removeMany(state, outdatedItems);
        state.isIrrelevant = true;
      }
    },
    setOffset: (state, action) => {
      state.options.offset = action.payload;
    },
    setLimit: (state, action) => {
      state.options.limit = action.payload;
    },
    setSort: (state, action) => {
      state.options.sort = action.payload;
    },
    setIrrelevant: (state, action) => {
      state.isIrrelevant = action.payload;
    }
  }
});
const reducer = persistReducer(
  {
    key: slice.reducerPath,
    version: 1,
    storage,
    blacklist: ["options", "isIrrelevant"]
  },
  slice.reducer
);
const { actions, reducerPath } = slice;
const selectors = adapter.getSelectors();
export {
  actions,
  adapter,
  reducer,
  reducerPath,
  selectors,
  slice
};
